import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col, Row,
} from 'reactstrap';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';
const HubDutyConfigDetails = ({ reactTableData }) => {
  const [rows] = useState(reactTableData.tableRowsData);
  const { t } = useTranslation('common');
  const tableConfig = {
    isEditable: false,
    isSortable: true,
    isResizable: true,
    withPagination: true,
    withSearchEngine: true,
    manualPageSize: [10, 50, 100, 1000],
    placeholder: 'Search by Hub Name ...',
  };
  return (
    <div className="mt-2">
      <ReactTableBase
        name={t('instution_type.view.name_map')}
        key={'searchable'}
        columns={reactTableData.tableHeaderData}
        data={rows}
        tableConfig={tableConfig}
      />
    </div>
  );
};

HubDutyConfigDetails.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default HubDutyConfigDetails;
